var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      {
        staticClass: "clearfix",
        attrs: { slot: "header", id: "device-settings" },
        slot: "header",
      },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v("Dynamic Settings"),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.showOnlyAppSettings,
                  callback: function ($$v) {
                    _vm.showOnlyAppSettings = $$v
                  },
                  expression: "showOnlyAppSettings",
                },
              },
              [_vm._v("Only App")]
            ),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _vm.allowPlaySound
              ? _c("play-sound-test", {
                  attrs: { placement: "left" },
                  on: {
                    execute: function (type) {
                      return _vm.executePlaySound(type)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.allowThroughputTest
              ? _c("ThroughputTest", {
                  staticStyle: { display: "inline-block" },
                  attrs: { "device-kind": _vm.deviceKind },
                  on: { execute: _vm.executeTest },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _vm.ready
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
          },
          [
            _c("DynamicSettings", {
              attrs: {
                "app-host": "ND",
                device: _vm.device,
                "json-schema": _vm.jsonSchema,
                "mobile-app": _vm.showOnlyAppSettings,
                "is-admin": _vm.isAdmin,
              },
              on: {
                "load-schema": _vm.fetchJsonSchema,
                error: _vm.errorDynamicSettings,
                "update-setting": _vm.onUpdateDynamicSetting,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "card-content",
            staticStyle: { "text-align": "center" },
          },
          [
            _vm.loading
              ? _c("h1", [_vm._v("\n      Loading Device Settings\n    ")])
              : _c("div", [
                  _c("h1", [_vm._v("Problem loading settings")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Reload the page, if the problem continue contact Admin"
                    ),
                  ]),
                ]),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }